<template>
  <div>
    <!-- Overlay para cerrar el menú en móvil -->
    <div 
      v-if="isMobile && isOpen" 
      class="sidebar-overlay"
      @click="closeSidebar"
    ></div>
    
    <nav class="sidebar" :class="{ 'sidebar-open': isOpen, 'sidebar-closed': !isOpen }">
      <!-- Botón para cerrar en móvil -->
      <button 
        v-if="isMobile" 
        class="sidebar-close-btn" 
        @click="closeSidebar"
      >
        ✕
      </button>

      <div class="sidebar-logo" @click="goHome">
        <img src="/images/deportivopatria.jpg" alt="Deportivo Patria" />
        <h3 class="logo-text">Edutrack</h3>
      </div>
      <ul>
        <li v-if="tienePermisoAdministracion">
          <span class="menu-title">👨‍💼 Administración</span>
          <ul>
            <li v-if="puedeVerUsuarios" @click="handleNavigation('usuarios')">
              <span class="menu-icon">👤</span> Usuarios
            </li>
            <li v-if="puedeVerRoles" @click="handleNavigation('roles')">
              <span class="menu-icon">🔐</span> Roles
            </li>
            <li v-if="puedeVerHorarios" @click="handleNavigation('horarios')">
              <span class="menu-icon">🕒</span> Horarios
            </li>
          </ul>
        </li>
        <li v-if="tienePermisoAdministrativo">
          <span class="menu-title">📋 Administrativo</span>
          <ul>
            <li v-if="puedeVerTalleres" @click="handleNavigation('talleres')">
              <span class="menu-icon">⚽</span> Talleres
            </li>
            <li v-if="puedeVerAlumnos" @click="handleNavigation('alumnos')">
              <span class="menu-icon">👥</span> Alumnos
            </li>
            <li v-if="puedeVerPagos" @click="handleNavigation('pagos')">
              <span class="menu-icon">💰</span> Pagos
            </li>
            <li v-if="puedeVerCoordinacion" @click="handleNavigation('coordinacion')">
              <span class="menu-icon">👨‍🏫</span> Maestros
            </li>
            <li v-if="puedeVerReporteGeneral" @click="handleNavigation('reportegeneral')">
              <span class="menu-icon">📊</span> Reporte General
            </li>
            <li v-if="puedeVerReporteAsistencias" @click="handleNavigation('asistencia-reporte')">
              <span class="menu-icon">📋</span> Reporte de Asistencias
            </li>
          </ul>
        </li>
        <li v-if="talleres.length > 0">
          <span class="menu-title">🏃‍♂️ Mis Talleres</span>
          <ul>
            <li v-for="(taller, index) in talleres" :key="taller.id" @click="handleNavigation(index === 0 ? 'mitaller' : `mitaller${index + 1}`)">
              <span class="menu-icon">🎯</span> {{ taller.descripcion }}
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenu',
  data() {
    return {
      talleres: [],
      permisos: {},
      isMobile: false,
      isOpen: false
    };
  },
  computed: {
    // Permisos para Usuarios
    puedeVerUsuarios() {
      const permisosUsuarios = this.permisos['/usuarios'] || [];
      return permisosUsuarios.some(p => p.Descripcion === 'Mostrar Lista Usuarios');
    },
    
    // Permisos para Roles
    puedeVerRoles() {
      const permisosRoles = this.permisos['/roles'] || [];
      return permisosRoles.some(p => p.Descripcion === 'Mostrar Lista Roles');
    },
    
    // Permisos para Horarios
    puedeVerHorarios() {
      const permisosHorarios = this.permisos['/horarios'] || [];
      return permisosHorarios.some(p => p.Descripcion === 'Mostrar Lista Horarios');
    },
    
    // Permisos para Talleres
    puedeVerTalleres() {
      const permisosTalleres = this.permisos['/talleres'] || [];
      return permisosTalleres.some(p => p.Descripcion === 'Mostrar Lista Talleres');
    },
    
    // Permisos para Alumnos
    puedeVerAlumnos() {
      const permisosAlumnos = this.permisos['/alumnos'] || [];
      return permisosAlumnos.some(p => p.Descripcion === 'Mostrar Lista Alumnos');
    },
    
    // Permisos para Pagos
    puedeVerPagos() {
      const permisosPagos = this.permisos['/pagos'] || [];
      return permisosPagos.some(p => p.Descripcion === 'Mostrar Lista Pagos de Alumnos');
    },
    
    // Permisos para Coordinación
    puedeVerCoordinacion() {
      const permisosCoordinacion = this.permisos['/coordinacion'] || [];
      return permisosCoordinacion.some(p => p.Descripcion === 'Mostrar Lista Coordinacion');
    },

    // Permisos para Reporte General
    puedeVerReporteGeneral() {
      const permisosReporte = this.permisos['/reportegeneral'] || [];
      return permisosReporte.some(p => p.Descripcion === 'Mostrar Reporte General');
    },

    // Verificar si tiene al menos un permiso de administración
    tienePermisoAdministracion() {
      return this.puedeVerUsuarios || this.puedeVerRoles || this.puedeVerHorarios;
    },

    // Verificar si tiene al menos un permiso administrativo
    tienePermisoAdministrativo() {
      return this.puedeVerTalleres || this.puedeVerAlumnos || this.puedeVerPagos || this.puedeVerCoordinacion || this.puedeVerReporteGeneral;
    },

    // Verificar si tiene al menos un permiso de reportes
    tienePermisoReportes() {
      return this.puedeVerReporteGeneral;
    },

    // Permisos para ver reporte de asistencias
    puedeVerReporteAsistencias() {
      return true; // Mostrar siempre en sidebar, el acceso se controla en la vista
    }
  },
  mounted() {
    // Detectar si es móvil
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);

    // Obtener los talleres desde localStorage
    const talleresData = localStorage.getItem('talleres');
    if (talleresData) {
      try {
        const talleres = JSON.parse(talleresData);
        if (Array.isArray(talleres) && talleres.length > 0) {
          this.talleres = talleres;
        }
      } catch (e) {
        this.talleres = [];
      }
    }
    
    // Obtener los permisos desde localStorage
    try {
      const permisosData = localStorage.getItem('permisos');
      if (permisosData) {
        this.permisos = JSON.parse(permisosData);
      }
    } catch (e) {
      this.permisos = {};
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    goHome() {
      this.$emit('navigate', 'home');
      if (this.isMobile) {
        this.closeSidebar();
      }
    },
    handleNavigation(route) {
      this.$emit('navigate', route);
      if (this.isMobile) {
        this.closeSidebar();
      }
    },
    toggleSidebar() {
      if (this.isMobile) {
        this.isOpen = !this.isOpen;
      }
    },
    closeSidebar() {
      if (this.isMobile) {
        this.isOpen = false;
      }
    },
    openSidebar() {
      if (this.isMobile) {
        this.isOpen = true;
      }
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
      // En desktop, siempre mantener abierto (no visible porque está detrás)
      if (!this.isMobile) {
        this.isOpen = true;
      } else {
        // En móvil, iniciar cerrado SIEMPRE
        this.isOpen = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfMobile);
  }
};
</script>

<style>
/* Overlay para cerrar el menú en móvil */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(2px);
}

/* Sidebar principal */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background-color: #0a2860;
  padding: 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  z-index: 1002;
  transition: transform 0.3s ease;
}

/* Estados del sidebar */
.sidebar-closed {
  transform: translateX(-100%);
}

.sidebar-open {
  transform: translateX(0);
}

/* Botón para cerrar en móvil */
.sidebar-close-btn {
  position: absolute;
  top: 80px;
  right: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 1003;
}

.sidebar-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

/* Logo del sidebar */
.sidebar-logo {
  background-color: #0a2860;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
}

.sidebar-logo:hover {
  background-color: #3498db;
}

.sidebar-logo img {
  height: 150px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 5px;
}

.logo-text {
  color: #ecf0f1;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  margin-top: -10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Listas del menú */
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  margin: 0;
}

.menu-title {
  display: block;
  padding: 15px 20px 10px;
  color: #ecf0f1;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid hsl(210, 29%, 29%);
}

li > ul {
  background-color: #0d346b;
}

li > ul > li {
  padding: 12px 20px 12px 40px;
  color: #bdc3c7;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

li > ul > li:hover {
  background-color: #3498db;
  color: white;
  padding-left: 45px;
}

li > ul > li:last-child {
  border-bottom: none;
}

.menu-icon {
  display: inline-block;
  margin-right: 8px;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

/* RESPONSIVO COMPLETO SIDEBAR */

/* Tablets grandes */
@media (max-width: 1024px) {
  .sidebar {
    width: 240px;
    top: 58px;
    height: calc(100vh - 58px);
  }
  .sidebar-overlay {
    top: 58px;
    height: calc(100% - 58px);
  }
  .sidebar-logo {
    padding: 0.8rem;
  }
  .sidebar-logo img {
    height: 70px;
    max-width: 140px;
  }
  .logo-text {
    font-size: 15px;
  }
  .menu-title {
    font-size: 12px;
    padding: 10px 16px 8px;
  }
  li > ul > li {
    padding: 12px 16px 12px 28px;
    font-size: 13px;
  }
}

/* Tablets y móviles grandes */
@media (max-width: 768px) {
  .sidebar {
    width: 220px;
    top: 56px;
    height: calc(100vh - 56px);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
  }
  .sidebar-overlay {
    top: 56px;
    height: calc(100% - 56px);
  }
  .sidebar-close-btn {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
  .sidebar-logo {
    padding: 0.6rem;
  }
  .sidebar-logo img {
    height: 64px;
    max-width: 125px;
  }
  .logo-text {
    font-size: 13px;
  }
  .menu-title {
    font-size: 11px;
    padding: 9px 14px 7px;
  }
  li > ul > li {
    padding: 11px 14px 11px 26px;
    font-size: 12px;
  }
  li > ul > li:hover {
    padding-left: 30px;
  }
}

/* Móviles medianos */
@media (max-width: 640px) {
  .sidebar {
    width: 200px;
    top: 52px;
    height: calc(100vh - 52px);
  }
  .sidebar-overlay {
    top: 52px;
    height: calc(100% - 52px);
  }
  .sidebar-logo {
    padding: 0.5rem;
  }
  .sidebar-logo img {
    height: 56px;
    max-width: 110px;
  }
  .logo-text {
    font-size: 12px;
  }
  .menu-title {
    font-size: 10px;
    padding: 8px 12px 6px;
  }
  li > ul > li {
    padding: 10px 12px 10px 22px;
    font-size: 11px;
  }
}

/* Móviles pequeños */
@media (max-width: 480px) {
  .sidebar {
    width: 180px;
    top: 48px;
    height: calc(100vh - 48px);
  }
  .sidebar-overlay {
    top: 48px;
    height: calc(100% - 48px);
  }
  .sidebar-logo {
    padding: 0.4rem;
  }
  .sidebar-logo img {
    height: 48px;
    max-width: 90px;
  }
  .logo-text {
    font-size: 11px;
  }
  .menu-title {
    font-size: 9px;
    padding: 7px 10px 5px;
  }
  li > ul > li {
    padding: 9px 10px 9px 18px;
    font-size: 10px;
  }
  li > ul > li:hover {
    padding-left: 22px;
  }
}

/* Móviles ultra pequeños */
@media (max-width: 360px) {
  .sidebar {
    width: 160px;
    top: 44px;
    height: calc(100vh - 44px);
  }
  .sidebar-overlay {
    top: 44px;
    height: calc(100% - 44px);
  }
  .sidebar-close-btn {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
  .sidebar-logo {
    padding: 0.3rem;
  }
  .sidebar-logo img {
    height: 40px;
    max-width: 75px;
  }
  .logo-text {
    font-size: 10px;
  }
  .menu-title {
    font-size: 8px;
    padding: 6px 8px 4px;
  }
  li > ul > li {
    padding: 8px 8px 8px 16px;
    font-size: 9px;
  }
  li > ul > li:hover {
    padding-left: 20px;
  }
}

/* En pantallas grandes, el sidebar siempre está visible */
@media (min-width: 769px) {
  .sidebar {
    transform: translateX(0) !important;
  }
  
  .sidebar-close-btn {
    display: none !important;
  }
  
  .sidebar-overlay {
    display: none !important;
  }
}
</style>
